	<template>
        <!-- 排序题 -->
        <div class="sort-box">
            <ul ref="geoChilds" class="ulChildName before-sort">
                <template v-for="(item) in newData.sortArray">
                <li 
                    :key="item.oid"
                    class="info-body-item"
                    >
                    
                    <span 
                        :style="{
                            borderColor: item.optionIndex ? '#409EFF' : '#DCDFE6',
                            background: item.optionIndex ? '#409EFF' : '#fff',
                            color: item.optionIndex ? '#fff' : '#666'
                        }"
                        class="option-sort"
                    >{{item.optionIndex ? item.optionIndex : ''}}</span>
                    <HtmlClickImgEnlarge :content="item.labelName"/>
                </li>
                <div 
                    :key="`op${item.oid}`"
                    v-if="item.haveInput"
                    class="other-input">
                    <el-input
                        disabled
                        size="small"
                        placeholder="请输入"
                        v-model="item.inputValue"
                    >
                    </el-input>
                </div>
            </template>
        </ul>
    </div>
</template>

<script>
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue'
export default {
    name: 'SortType',
    components: {
        HtmlClickImgEnlarge
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
        }
    },
    computed: {
        newData() {
            return {...this.data}
        }
    },
    watch:{
        newData: {
            handler() {
                if(!this.newData.userAnswer) return
                this.$set(this.newData, 'userAnswerArr', this.newData.userAnswer)
                let sortArray = JSON.parse(JSON.stringify(this.newData.optionList))
                if (!this.newData.sortArray) {
                    this.$set(this.newData, 'sortArray', sortArray)
                    this.newData.sortArray = this.newData.sortArray.map((info) =>{
                        this.$set(info, 'optionIndex', 0)
                        this.newData.userAnswerArr = this.newData.userAnswerArr.map((item, index)=>{
                            let answerArr = item.split(':')
                            if (answerArr[0] == info.oid) {
                                info.optionIndex = index + 1
                                if (answerArr.length > 1) {
                                    info.inputValue = answerArr[1]
                                    info.haveInput = true
                                    item = answerArr[0]
                                }
                            }
                            return item
                        })
                        return info
                    })
                    this.newData.sortArray.sort((a,b) => {
                        return a.optionIndex - b.optionIndex
                    })
                }
                // console.log(this.newData.userAnswerArr)
                console.log(this.newData.sortArray)
            },
            immediate: true
        }
    },
    created() {
    },
    methods: {
    }
    
}
</script>

<style scoped lang="scss">

	.ulChildName {
		// width: 100%;
		max-width: 50%;
		min-width: 250px;
		overflow: hidden;

		.info-body-item+.info-body-item {
			margin-top: 10px
		}
		.option-sort{
			display: inline-block;
			width: 17px;
			height: 15px;
			font-size: 12px;
			line-height: 15px;
			text-align: center;
			border: 1px solid #666;
			border-radius: 50%;
			margin-right: 10px;
		}
		.info-body-item {
			padding: 0 10px;
			line-height: 30px;
			font-size: 14px;
			width: 100%;
			border: 1px solid #ccc;
			border-radius: 4px;
			display: flex;
			align-items: center;
			box-sizing: border-box;
		}
	}
    .other-input{
        margin:10px 0;
    }
</style>
